:host {
    --wcs-list-item-properties-margin-bottom: var(--wcs-semantic-spacing-small);
    --wcs-list-item-properties-gap: calc(4 * var(--wcs-semantic-spacing-base));
    --wcs-list-item-properties-separator-width: var(--wcs-semantic-border-width-large);
    --wcs-list-item-properties-separator-color: var(--wcs-semantic-color-border-secondary);

    display: flex;
    margin-bottom: var(--wcs-list-item-properties-margin-bottom);
    gap: var(--wcs-list-item-properties-gap);
}

::slotted(*:not(:last-of-type)) {
    position: relative;

    &::after {
        position: absolute;
        content: '';
        top: 0;
        height: 100%;
        width: var(--wcs-list-item-properties-separator-width);
        background-color: var(--wcs-list-item-properties-separator-color);
        right: calc(-0.5 * var(--wcs-list-item-properties-gap) - 0.5 * var(--wcs-list-item-properties-separator-width));
    }
}

